import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import './index.css'
import 'react-toastify/dist/ReactToastify.css';
import App from './App'
import {ToastContainer} from "react-toastify";
import {MaintenanceProvider} from './maintenance/MaintenanceContext';
import MaintenanceGate from './maintenance/MaintenanceGate';
import {NonceProvider} from "react-select";
import {CacheProvider} from '@emotion/react';
import createCache from '@emotion/cache';
import { ThemeProvider } from '@material-tailwind/react';

const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') ?? '';
const cache = createCache({key: 'react-select', nonce});

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <ThemeProvider value={{ ripple: false }}>
            <MaintenanceProvider>
                <MaintenanceGate>
                    <NonceProvider nonce={nonce} cacheKey="react-select">
                        <CacheProvider value={cache}>
                            <App/>
                        </CacheProvider>
                    </NonceProvider>
                </MaintenanceGate>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                />
            </MaintenanceProvider>
        </ThemeProvider>
    </StrictMode>,
)
